import React from 'react';
import type { FiboCollectionComboboxItem } from '@/models/fibo/fibosearch';

import { FibosearchCombobox } from './FibosearchCombobox';
import { RenderItem } from '@/components/fibosearch/FibosearchCombobox/RenderItem';

export type SimpleListProps = {
  collections: FiboCollectionComboboxItem[];
  inputValue: string;
};

export const CollectionList = ({ inputValue, collections }: SimpleListProps) => (
  <FibosearchCombobox.List>
    {collections.map((item) => (
      <RenderItem key={JSON.stringify(item)} item={item} inputValue={inputValue} />
    ))}
  </FibosearchCombobox.List>
);
